import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M327.9 2.2c-7.6 4.5-10.2 14.2-5.8 21.9l98 167.9H155.8l98-167.9c4.5-7.6 1.9-17.4-5.8-21.9S230.6.3 226.1 8L118.8 192H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h24l59.9 239.5C107 492 132.6 512 162 512h252c29.4 0 55-20 62.1-48.5L536 224h24c8.8 0 16-7.2 16-16s-7.2-16-16-16H457.2L349.8 7.9c-4.5-7.6-14.2-10.2-21.9-5.8zM73 224h430l-57.9 231.8C441.5 470 428.7 480 414 480H162c-14.7 0-27.5-10-31-24.2zm151 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16zm64-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16m96 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    }, null, -1)
  ])))
}
export default { render: render }